// extracted by mini-css-extract-plugin
export var aircallIframe = "_kr-3";
export var fabContainer = "_kr-5";
export var fabRinging = "_kr-6";
export var loadingOverlay = "_kr-4";
export var pulse = "_kr-7";
export var widgetContent = "_kr-2";
export var widgetPanel = "_kr-0";
export var widgetPanelExpanded = "_kr-1";